module.exports = __webpack_public_path__ + "img/success.7ead9341.svg";